// extracted by mini-css-extract-plugin
module.exports = {"blockIcons":"test-mts-icons_blockIcons__35X8D","list":"test-mts-icons_list__3CGEM","listItem":"test-mts-icons_listItem__bMsE6","listItemText":"test-mts-icons_listItemText__1d2gx"};